import { Component, OnInit, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SiteState } from '../shared/models';
import { getCropYear } from '../store/selectors';

@Component({
  selector: 'app-field-advice-customer-selection-custom-config',
  templateUrl: './customer-selection-custom-config.component.html',
  standalone: false,
})
export class FieldAdviceCustomerSelectionCustomConfigComponent implements OnInit {
  protected readonly store = inject<Store<SiteState>>(Store);

  cropYear: number = this.getDefaultCropYear();
  cropYear$ = this.store.pipe(select(getCropYear));

  ngOnInit(): void {
    this.cropYear$.subscribe((cropYear) => {
      if (cropYear) {
        this.cropYear = cropYear;
      } else {
        return this.getDefaultCropYear();
      }
    });
  }

  getDefaultCropYear(): number {
    const currentDate = new Date();
    if (currentDate.getMonth() >= 10) {
      return currentDate.getFullYear() + 1;
    }
    return currentDate.getFullYear();
  }
}
